module.exports = __webpack_public_path__ + "static/media/J9.ed5c1e35.png";